import { SubParticipantStatId } from '../enums/SubParticipantStatId.js'
import { BaseParticipant } from './BaseParticipant.js'
import { Stat } from './Stat.js'

export enum SubParticipantPosition {
  Goalkeeper = 'goalkeeper',
  FirstLineup = '1st lineup',
  StartingLineup = 'starting lineup',
  Bench = 'bench',
  Coach = 'coach',
  WillNotPlay = 'will not play',
  Player = 'player',
  Batter = 'batter',
  Pitcher = 'pitcher',
}

/** Baseball lineup flags persisted on `GET/POST` sub-participants. */
export enum SubParticipantFlag {
  PossibleBatter = 'possible_batter',
}

export type SubParticipant = Omit<BaseParticipant, 'stats' | 'id'> & {
  id: BaseParticipant['id'] | null
  position: SubParticipantPosition
  participant_id: number
  lineup_id: number
  captain: boolean
  position_reason_code?: string
  position_reason_id?: number
  position_detailed_reason_id?: number
  team_id?: string
  stats?: Stat<SubParticipantStatId>[]
  flags?: SubParticipantFlag[]
}
